module.exports = __webpack_public_path__ + "img/news6.661df876.jpg";